module.exports = __webpack_public_path__ + "static/media/close.50d52aad.svg";